/**
 * NotificacionEnviadaRepo sobre Supabase. Bitácora compartida (append-only)
 * de intentos de envío de correo.
 */

import type { NotificacionEnviadaRepo } from "../../repos/NotificacionEnviadaRepo";
import type { NotificacionEnviada } from "@app-types/entities";
import { SupabaseBaseRepo } from "./SupabaseBaseRepo";

export class SupabaseNotificacionEnviadaRepo
  extends SupabaseBaseRepo<NotificacionEnviada>
  implements NotificacionEnviadaRepo
{
  constructor(tenantId: string) {
    super("notificacionEnviada", tenantId);
  }

  async list(filter?: {
    handoverId?: string;
    actor?: string;
    desde?: string;
    hasta?: string;
  }): Promise<NotificacionEnviada[]> {
    let rows = await this.listAll();
    if (filter?.handoverId) rows = rows.filter((r) => r.handoverId === filter.handoverId);
    if (filter?.actor) rows = rows.filter((r) => r.actor === filter.actor);
    if (filter?.desde) rows = rows.filter((r) => r.fechaIntento >= filter.desde!);
    if (filter?.hasta) rows = rows.filter((r) => r.fechaIntento <= filter.hasta!);
    return rows.sort((a, b) => b.fechaIntento.localeCompare(a.fechaIntento));
  }

  async get(id: string): Promise<NotificacionEnviada | null> {
    return this.getById(id);
  }

  async create(
    data: Omit<NotificacionEnviada, "id" | "tenantId" | "createdAt" | "updatedAt" | "version">,
  ): Promise<string> {
    const now = new Date().toISOString();
    const nuevo: NotificacionEnviada = {
      ...data,
      id: crypto.randomUUID(),
      tenantId: this.tenantId,
      version: 1,
      createdAt: now,
      updatedAt: now,
    };
    await this.createRaw(nuevo);
    return nuevo.id;
  }
}
